import React, { useRef } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Pathway } from './components/sections/Pathway';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Audience } from './components/sections/Audience';
import { HowItWorks } from './components/sections/HowItWorks';
import { Testimonials } from './components/sections/Testimonials';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Author } from './components/sections/Author';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  const heroCtaRef = useRef<HTMLAnchorElement>(null);
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-navy" data-id="element-0" data-mp="3mjztd6hzp62c">
      <MetaPixel data-id="element-1" data-mp="3rdkl4gszp3t3" />
      <Hero ctaRef={heroCtaRef} data-id="element-2" data-mp="3rd189ei755lx" />
      <main data-id="element-3" data-mp="5ott78p769p">
        <Problem data-id="element-4" data-mp="6htxpd5ixiv" />
        <Pathway data-id="element-5" data-mp="4wyzymxdckh" />
        <BeforeAfter data-id="element-6" data-mp="5gbv0xpxarn" />
        <Volumes data-id="element-7" data-mp="7suzhf7pr6a" />
        <Bonuses data-id="element-8" data-mp="2zld0l5ad579f" />
        <Audience data-id="element-9" data-mp="2zlv7cvunj3vl" />
        <HowItWorks data-id="element-10" data-mp="2zmeoiach9o8k" />
        <Testimonials data-id="element-11" data-mp="2zmwhmy3ufmc9" />
        <Offer data-id="element-12" data-mp="33mou3lwcycmw" />
        <Guarantee data-id="element-13" data-mp="33mf6g4yschkd" />
        <Author data-id="element-14" data-mp="33nq5xsl7735o" />
        <FAQ data-id="element-15" data-mp="33n6zp94wu37h" />
        <FinalCTA data-id="element-16" data-mp="33myl9ct52pu6" />
      </main>
      <Footer data-id="element-17" data-mp="38lrs4mdx7ild" />
      <FloatingCTA triggerRef={heroCtaRef} data-id="element-18" data-mp="38l8h7pmotugu" />
      <PurchasePopup data-id="element-19" data-mp="38kgkgbhctqoz" />
    </div>;
}